import { Country } from './country-model';

export class Address {
    '@type': string;
    addressCountry: Country;
    addressRegion: string;
    addressLocality: string;
    postalCode: string;
    streetAddress: string;
    constructor(addressCountry: Country, addressRegion: string, addressLocality: string, postalCode: string, streetAddress: string) {
        this['@type'] = 'PostalAddress';
        this.addressCountry = addressCountry,
            this.addressRegion = addressRegion,
            this.addressLocality = addressLocality,
            this.postalCode = postalCode,
            this.streetAddress = streetAddress;
    }
}
